import {Routes} from '@angular/router'
import {
  adminAuthGuard,
  LoginComponent
} from '@sparbanken-syd/sparbanken-syd-bankid'
import {LOGIN_ROUTE_PATH} from './application/app'
import {IdListComponent} from './id-list/id-list.component'

export const routes: Routes = [
  {
    path: 'admin',
    component: IdListComponent,
    canActivate: [adminAuthGuard]
  },
  {
    path: LOGIN_ROUTE_PATH,
    component: LoginComponent
  },
  {
    path: '**',
    redirectTo: LOGIN_ROUTE_PATH
  }
]